module.exports = __webpack_public_path__ + "static/img/1.be0f446.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/1.jpg
// module id = Eg2R
// module chunks = 1